import a from "react";
import { extendTheme as l, ChakraProvider as c } from "@chakra-ui/react";
import { Theme as e } from "../../themes/themes.js";
import { BASE_FONT as i } from "../../types/constants.js";
import "@chakra-ui/system";
import { tokenTransform as f } from "../../utils/tokenTransformWithBaseFont.js";
const s = { ...e.localTokens }, S = ({
  children: t,
  baseTheme: o,
  baseFont: m = i
}) => {
  const r = f(s, m);
  if (!r || !o)
    return null;
  e.localTokens = { ...r };
  const n = l(o, e);
  return /* @__PURE__ */ a.createElement(c, { theme: n }, t);
};
export {
  S as SSRThemeProvider
};
